import { getSetting } from '@disy/workbook.lib/settings';

import { getStore } from 'cadenza/store/cadenza-store';
import type { ActiveAttributeId } from 'cadenza/workbook/api/active-attribute-id';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import { getGeometryAttributeActiveId } from 'cadenza/workbook/data-view/data-view-utils';
import type { AttributeId } from 'cadenza/workbook/model/attribute-id.gen';
import type { ClassificationType } from 'cadenza/workbook/model/classification-type.gen';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { isAttributeToOneReachableFrom } from 'cadenza/workbook/state/workbook-reachability.state';
import { getAttributeById } from 'cadenza/workbook/workbook-core-selectors.state';
import { measureTypeAllowsUniqueValueClassification } from 'cadenza/workbook/workbook-panel/settings/map/advanced-data-layer-settings/advanced-style-property-classification-settings-utils';

export const COMBINED_CLASSIFICATION_PREVIEW_COLUMN_WIDTH = '60px';

export function getClassificationType(classificationActiveAttributeId: AttributeId | ActiveAttributeId) {
  const classificationAttr = getAttributeById(getStore().getState(), classificationActiveAttributeId);
  return getClassificationTypeFromAttribute(classificationAttr);
}

export function getClassificationTypeFromAttribute(attribute: WorkbookAttributeDto) {
  const isMeasure = attribute.category === 'MEASURE';
  const defaultValue = isMeasure ? 'INTERVAL' : 'UNIQUE_VALUES';
  return getSetting<ClassificationType>(attribute, 'CLASSIFICATION_TYPE') || defaultValue;
}

export function createSymbolizationTypeViewModel(
  dataViewId: DataViewId,
  classificationActiveAttributeId: ActiveAttributeId,
) {
  const classificationAttr = getAttributeById(getStore().getState(), classificationActiveAttributeId);
  const isMeasure = classificationAttr.category === 'MEASURE';
  const value = getClassificationType(classificationActiveAttributeId);
  const targetAttributeId = getGeometryAttributeActiveId(dataViewId);
  const isTo1GeometryLinkedMeasure =
    targetAttributeId &&
    isMeasure &&
    measureTypeAllowsUniqueValueClassification(classificationAttr.type) &&
    isAttributeToOneReachableFrom(
      getStore().getState(),
      classificationAttr,
      getAttributeById(getStore().getState(), targetAttributeId),
    );
  const isReadOnly = !isTo1GeometryLinkedMeasure;
  return { value, isReadOnly };
}
